import React from 'react';
/*import Select from 'react-select';*/
import { toast } from 'react-toastify';
import {FormText } from 'reactstrap';
import DEBUG from "config/debug.js"
import Presenter from '../../presenter.js';
import RequestProperties from '../request.props.js';
import PhoneInput from 'react-phone-number-input'
import FormHelper from '../form.js';
import {ButtonValidation, ButtonCancel} from '../../../../component/Button.js'
import SelectQuery from '../../../../component/SelectQuery.js';
import windowStop from '../../../../utils/windowStop.js';

export default class Tenant extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      id             : props.match.params.id,
      type           : "",
      company_name   : "",
      website        : "",
      company_phone  : "",
      name           : "",
      address        : "",
      address2       : "",
      city           : undefined,
      init_city      : "",
      postal         : "",
      phone          : "",
      mobile         : "",
      email          : "",
      business_model : undefined,
      custom_branding: false,
      init_business_model : "",
      is_lite        : false,
      disabledField  : false,
      is_process     : false,
    }

    this.onRegister         = this.onRegister.bind(this)
    this.RegisterSuccess    = this.RegisterSuccess.bind(this)
    this.RegisterFailed     = this.RegisterFailed.bind(this)

    this.onUpdateMode           = this.onUpdateMode.bind(this)
    this.onUpdate           = this.onUpdate.bind(this)
    this.UpdateSuccess      = this.UpdateSuccess.bind(this)
    this.UpdateFailed       = this.UpdateFailed.bind(this)

    this.onDetail           = this.onDetail.bind(this)
    this.DetailSuccess      = this.DetailSuccess.bind(this)
    this.DetailFailed       = this.DetailFailed.bind(this)
    this.cancelUpdate       = this.cancelUpdate.bind(this)

  }

  handleCheckboxChange(event) {
    this.setState({
      custom_branding: event.target.checked
    })
  }

  handleLiteCheckboxChange(event) {
    this.setState({
      is_lite   : event.target.checked
    })
  }

  handleCity(event) {
    if(event === null || event === undefined || event === "") {
      this.setState({city: ""})
    } else {
      this.setState({city: event.value})
    }
  }

  handleBussinesModel(event) {
    if(event === null || event === undefined || event === "" ) {
      this.setState({business_model: ""})
    } else {
      this.setState({business_model: event.value})
    }
  }

  onRegister() {
    if(!FormHelper.ValidateForm(this.state)) return

    this.setState({is_process: true})
    Presenter.Register(RequestProperties.Register(this, this.RegisterSuccess, this.RegisterFailed))
  }

  RegisterSuccess(params, response) {
    this.setState({is_process: false})
    toast.success("Create tenant success")
    this.props.history.push('/su/tenant-list')
  }

  RegisterFailed(error) {
    this.setState({is_process: false})
    if(error.hasOwnProperty('response')) {
      if(error.response.hasOwnProperty('data')) {

        for(let key in error.response.data) {
          for(let nested_key in error.response.data[key]) {
            toast.error(error.response.data[key][nested_key])
          }
        }
      }
    } else {
      toast.error("Create tenant failed")
    }
  }

  onUpdateMode() {
    this.setState({disabledField: false})
    this.props.history.push('/su/tenant/update/' + this.state.id)
  }

  cancelUpdate() {
    this.setState({disabledField: true})
    this.props.history.push('/su/tenant/detail/' + this.state.id)
  }

  onUpdate() {
    // Notes: Validation is top
    if(!FormHelper.ValidateForm(this.state)) return

    this.setState({is_process: true})
    Presenter.Update(
      RequestProperties.Update(this, this.UpdateSuccess, this.UpdateFailed)
    )
  }

  UpdateSuccess(params, response) {
    toast.success("Update tenant success")
    this.cancelUpdate()
    this.setState({is_process: false})
  }

  UpdateFailed(error) {
    this.setState({is_process: false})

  }

  onDetail() {
    Presenter.Detail(
      RequestProperties.Detail(this, this.DetailSuccess, this.DetailFailed)
    )
  }

  DetailSuccess(params, response) {
    const {data} = response

    this.setState({
      type           : data.Type,
      company_name   : data.CompanyName,
      website        : data.Website,
      company_phone  : data.CompanyPhone,
      name           : data.Name,
      address        : data.Address,
      address2       : data.Address2,
      city           : data.City === null ? "" : data.City.pk,
      init_city      : {
        pk : data.City === null ? "" : data.City.pk,
        Name : data.City === null ? "" : data.City.Name,
      },
      postal         : data.Postal,
      phone          : data.Phone,
      mobile         : data.Mobile,
      email          : data.Email,
      business_model : data.BusinessModel.Alias,
      custom_branding: data.CustomBranding,
      is_lite        : data.is_lite,
      init_business_model      : {
        Alias : data.BusinessModel.Alias,
        Name : data.BusinessModel.Name,
      },

    })
  }

  DetailFailed(error) {
    DEBUG && console.log(error)
  }

  renderTitle(mode) {
    let title = null;

    if(mode === "create") {
      title = "Create new tenant"

    } else if(mode === "update"){
      title = "Update tenant"

    } else {
      title = "Detail tenant"

    }

    return title
  }

  renderButton(mode) {
    const {is_process} = this.state

    if(mode === "create") {
      return <ButtonValidation is_process={is_process} onClick={this.onRegister}>Create</ButtonValidation>
    } else if(mode === 'update'){
      return (
        <div>
          <ButtonCancel onClick={this.cancelUpdate}>Cancel</ButtonCancel>&nbsp;&nbsp;
          <ButtonValidation is_process={is_process} onClick={this.onUpdate}>Save Update</ButtonValidation>
        </div>
        )
    } else {
      return <button type="button" onClick={this.onUpdateMode} className="btn btn-primary">Edit Tenant</button>
    }

  }

  componentDidMount() {
    const {mode} = this.props

    if(mode === 'update') {
      this.onDetail()
    } else if (mode === 'detail'){
      this.onDetail()
      this.setState({disabledField: true})
    }
  }

  componentWillUnmount() {
    windowStop()
  }

  render() {
    const {mode} = this.props
    const {disabledField} = this.state

    return (
      <div className="card-block">
        <div className="page-header white-background">
        <h4>
          <i onClick={()=>this.props.history.push('/su/tenant-list')} className="fa fa-arrow-left spaceRRR" role="button"></i>
          {this.renderTitle(mode)}
        </h4>
        </div>
        <hr/>
        <div className="form-group">
          <div className="row">
            <div className="form-group col-md-8">
              <label className="required">Name</label>
              <input
                type="text"
                className="form-control"
                placeholder="Enter Tenant Name" 
                autoComplete="new-password"
                value={this.state.name}
                maxLength="100"
                onChange={(e)=>this.setState({name: e.target.value})}
                disabled={disabledField}
              />
            </div>
            <div className="form-group col-md-4">
              <label className="required">Type</label>
              <input
                type="text"
                className="form-control"
                placeholder="Enter Tenant Type"
                autoComplete="new-password"
                value={this.state.type}
                onChange={(e)=>this.setState({type: e.target.value})}
                disabled={disabledField}
              />
            </div>
            <div className="form-group col-md-8">
              <label className="required">Phone</label>
              <PhoneInput
                className="form-control"
                autoComplete="new-password"
                placeholder="Enter Phone Number"
                value={ this.state.phone }
                onChange={ phone => this.setState({ phone }) }
                disabled={disabledField}
              />
              {/*<input
                type="number"
                className="form-control"
                placeholder="Enter Phone Number"
                value={this.state.phone}
                maxLength="20"
                onChange={(e)=>this.setState({phone: e.target.value})}
                disabled={disabledField}
              />*/}
            </div>
            <div className="form-group col-md-4">
              <label className="required">Mobile</label>
              <PhoneInput
                className="form-control"
                placeholder="Enter Mobile Number"
                autoComplete="new-password"
                value={ this.state.mobile }
                onChange={ mobile => this.setState({ mobile }) }
                disabled={disabledField}
              />
            {/*<input
                type="number"
                className="form-control"
                placeholder="Enter Mobile Number"
                value={this.state.mobile}
                maxLength="20"
                onChange={(e)=>this.setState({mobile: e.target.value})}
                disabled={disabledField}
              />*/}
            </div>
            <div className="form-group col-md-8">
              <label className="required">Email</label>
              <input
                type="email"
                className="form-control"
                placeholder="Enter Email"
                autoComplete="new-password"
                value={this.state.email}
                maxLength="100"
                onChange={(e)=>this.setState({email: e.target.value})}
                disabled={disabledField}
              />
            </div>
            <div className="form-group col-md-4">
             <label className="required">Website</label>
             <input
               type="text"
               className="form-control"
               placeholder="example: http://asetvault.com"
                autoComplete="new-password"
               value={this.state.website}
               maxLength="100"
               onChange={(e)=>this.setState({website: e.target.value})}
               disabled={disabledField}
             />
              <FormText color="muted">
                Input with protocol: http, https
              </FormText>
            </div>

            <div className="form-group col-md-4">
              <div><label className="optional">Lite Version</label></div>
              <label className="switch switch-lg switch-text switch-primary mb0">
                <input
                  onChange={(event)=>this.handleLiteCheckboxChange(event)}
                  type="checkbox"
                  className="switch-input"
                  checked={this.state.is_lite}
                  disabled={disabledField}
                />
                <span className="switch-label" data-on="On" data-off="Off"></span>
                <span className="switch-handle"></span>
              </label>
            </div>

            <div className="list-separator m-top-15 sfl">
              <div className="item-inner">COMPANY</div>
            </div>

            {/* COMPANY */}
            <div className="form-group col-md-8">
              <label className="required">Company Name</label>
              <input
                type="text"
                className="form-control"
                placeholder="Enter Company Name"
                autoComplete="new-password"
                value={this.state.company_name}
                maxLength="100"
                onChange={(e)=>this.setState({company_name: e.target.value})}
                disabled={disabledField}
              />
            </div>
            <div className="form-group col-md-4">
              <label className="required">Company Phone</label>
              <PhoneInput
                className="form-control"
                placeholder="Enter company phone number"
                autoComplete="new-password"
                value={ this.state.company_phone }
                onChange={ company_phone => this.setState({ company_phone }) }
                disabled={disabledField}
              />
              {/*<input
                type="number"
                className="form-control"
                placeholder="Enter Company Phone Number"
                value={this.state.company_phone}
                maxLength="20"
                onChange={(e)=>this.setState({company_phone: e.target.value})}
              />*/}
            </div>
            <div className="form-group col-md-8">
              <label className="required">City</label>
              <SelectQuery
                placeholder="Enter City" 
                value={this.state.city}
                onChange={(e) => this.setState({city: e.value})}
                urlKey="read-city-autocomplete"
                valKey="pk"
                valLabel="Name"
                initOption={this.state.init_city}
                isCreatable={false}
                disabled={disabledField}
                UserReducer={this.props.UserReducer}
              />
            </div>
            <div className="form-group col-md-4">
              <label className="required">Postal</label>
              <input
                type="text"
                className="form-control"
                autoComplete="new-password"
                placeholder="Enter Postal"
                value={this.state.postal}
                maxLength="15"
                onChange={(e)=>this.setState({postal: e.target.value})}
                disabled={disabledField}
              />
            </div>
            {/*  */}
            <div className="form-group col-md-8">
              <label className="required">Address</label>
              <input
                type="text"
                className="form-control"
                placeholder="Enter Company Name"
                autoComplete="new-password"
                value={this.state.address}
                maxLength="300"
                onChange={(e)=>this.setState({address: e.target.value})}
                disabled={disabledField}
              />
            </div>
            <div className="form-group col-md-4">
              <label className="required">Address 2</label>
              <input
                type="text"
                className="form-control"
                autoComplete="new-password"
                placeholder="Enter Address 2"
                value={this.state.address2}
                maxLength="300"
                onChange={(e)=>this.setState({address2: e.target.value})}
                disabled={disabledField}
              />
            </div>
            <div className="form-group col-md-8">
              <label className="required">Business Model</label>
              <SelectQuery
                placeholder="Enter Business Model"
                value={this.state.business_model}
                onChange={(e) => this.setState({business_model: e.value})}
                urlKey="read-bussiness-autocomplete"
                valKey="Alias"
                valLabel="Name"
                initOption={this.state.init_business_model}
                isCreatable={false}
                UserReducer={this.props.UserReducer}
                disabled={disabledField}
              />
            </div>
            <div className="form-group col-md-4">
              <div><label className="optional">Custome branding</label></div>
              <label className="switch switch-lg switch-text switch-primary mb0">
                <input
                  onChange={(event)=>this.handleCheckboxChange(event)}
                  type="checkbox"
                  className="switch-input"
                  checked={this.state.custom_branding}
                  disabled={disabledField}
                />
                <span className="switch-label" data-on="On" data-off="Off"></span>
                <span className="switch-handle"></span>
              </label>
            </div>
            <div className="col-md-12">
              <hr/>
              <div className="right-align">
                {this.renderButton(mode)}
              </div>

            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/App/tenant/tenant/helper/component/Tenant.js